import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getOnlineUsers = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/online-users`);
    return response.data;
  } catch (error) {
    console.error(
      'Error fetching online users:',
      error.response?.data || error,
    );
    throw error;
  }
};
